import { Apuracao } from '@/types/apuracao'
import { TypeViewProduct } from '../state/selectProduct'
import InfoProductPanel from './situacao/info-panel-product'
import ObservationClient from '@/features/client/components/observation-cliente'
import { useFetchClientByCnpjCpf } from '@/features/client/services'

type ClientInfo = {
  parceiro: string
  empresa: string
  nomeAnalista: string
  status?: string
  id_client?: string
}
type ProductDashboardProps = {
  clientInfo: ClientInfo
  cnpj: string
  productId?: string
  type?: TypeViewProduct
  apuracoes?: Apuracao[]
  selectedApuracao?: Apuracao | null
}

export default function ProductDashboard({
  clientInfo,
  cnpj,
  productId,
  type = 'GERAL',
  apuracoes
}: ProductDashboardProps) {
  const { data: clientData } = useFetchClientByCnpjCpf(cnpj)

  clientInfo.parceiro = clientData.nome_responsavel
  clientInfo.id_client = cnpj

  return (
    <div className="container mx-auto p-0 space-y-6">
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <div className="order-1">
          <InfoProductPanel clientInfo={clientInfo} productId={productId} type={type} apuracoes={apuracoes} />
        </div>

        {/* Observations Panel */}
        <div className="order-2">
          <ObservationClient type={type} cnpj={cnpj} id={productId} />
        </div>
      </div>
    </div>
  )
}
